import { Config } from "../core/config/config.js";
import React from "react";
export class PDFPagePreview extends React.Component<{ pdfGuid: string; pageNumber: number; }, any> {
    private canvasRef: any;
    constructor(props) {
        super(props);
        this.canvasRef = React.createRef();
    }

    componentDidMount() {
        this.renderPDF();
    }

    async renderPDF() {
        const { pdfGuid, pageNumber } = this.props;

        try {
            pdfjsLib.GlobalWorkerOptions.workerSrc = Config.baseUrl + 'Scripts/smartSearch/pdf.worker.min.js';
            const pdf = await pdfjsLib.getDocument(
                {
                    url: `${Config.baseUrl}PdfPagePreviewCached/GetPdfPage?pdfGuid=${pdfGuid}&page=${pageNumber}`
                }).promise;
            const page = await pdf.getPage(1);

            const viewport = page.getViewport({ scale: 1.0 }); // Skalierung der Seite
            const canvas = this.canvasRef.current;
            const context = canvas.getContext('2d');
            const scale = canvas.width / viewport.width;
            const scaledViewport = page.getViewport({ scale: 0.8 });

            // Passe die Canvas-Gr��e an die PDF-Seite an
            canvas.width = scaledViewport.width;
            canvas.height = scaledViewport.height;

            // Rendere die Seite auf das Canvas
            const renderContext = {
                canvasContext: context,
                viewport: scaledViewport,
            };
            await page.render(renderContext).promise;
        } catch (error) {
            console.error('Fehler beim Rendern der PDF-Seite:', error);
        }
    }

    render() {
        return <div style={{ width: "100%", height: "350px", overflow: "hidden" }}><canvas ref={this.canvasRef} style={{}}></canvas></div>;
    }
}
